import React from 'react';
import styled from 'styled-components';
import { useAWSAuth } from '../../hooks/useAWSAuth';

const StatusContainer = styled.div`
  background: #f8f9fa;
  border: 1px solid #dee2e6;
  border-radius: 8px;
  padding: 12px 16px;
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
`;

const StatusBadge = styled.span<{ isAuthenticated: boolean }>`
  display: inline-flex;
  align-items: center;
  padding: 4px 12px;
  border-radius: 20px;
  font-weight: 600;
  font-size: 12px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  
  ${props => props.isAuthenticated ? `
    background: #d4edda;
    color: #155724;
    border: 1px solid #c3e6cb;
  ` : `
    background: #f8d7da;
    color: #721c24;
    border: 1px solid #f5c6cb;
  `}
`;

const StatusIcon = styled.span<{ isAuthenticated: boolean }>`
  margin-right: 6px;
  font-size: 10px;
`;

const EnvironmentInfo = styled.div`
  color: #6c757d;
  font-size: 12px;
  display: flex;
  align-items: center;
  gap: 8px;
`;

const EnvironmentBadge = styled.span`
  background: #e9ecef;
  color: #495057;
  padding: 2px 8px;
  border-radius: 12px;
  font-weight: 500;
  text-transform: uppercase;
  font-size: 11px;
`;

export const AWSStatusIndicator: React.FC = () => {
  const { isAuthenticated, environmentInfo, error } = useAWSAuth();

  return (
    <StatusContainer>
      <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
        <StatusBadge isAuthenticated={isAuthenticated}>
          <StatusIcon isAuthenticated={isAuthenticated}>
            {isAuthenticated ? '●' : '●'}
          </StatusIcon>
          {isAuthenticated ? 'AWS Connected' : 'AWS Disconnected'}
        </StatusBadge>
        
        {error && (
          <span style={{ color: '#dc3545', fontSize: '12px' }}>
            Error: {error}
          </span>
        )}
      </div>

      <EnvironmentInfo>
        <span>Environment:</span>
        <EnvironmentBadge>{environmentInfo.environment}</EnvironmentBadge>
        <span style={{ color: '#adb5bd' }}>|</span>
        <span style={{ fontFamily: 'monospace', fontSize: '11px' }}>
          {environmentInfo.baseUrl}
        </span>
      </EnvironmentInfo>
    </StatusContainer>
  );
};
